/** @jsxImportSource react */
import React, { InputHTMLAttributes, forwardRef } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
    // any additional props can be defined here
}

export const Input = forwardRef<HTMLInputElement, InputProps>(({ className = '', ...props }, ref) => {
    const baseClasses = 'w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all duration-200';

    return (
        <input
            ref={ref}
            className={`${baseClasses} ${className}`}
            {...props}
        />
    );
});
Input.displayName = 'Input';